//
//
//
//
//
//
//
//

export default {
  name: 'toolbar',

  props: {
    fixed: Boolean
  },

  computed: {
    classes () {
      return {
        'toolbar--fixed': this.fixed
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/toolbar/Toolbar.vue